/**
 * Created by gilk on 04/06/17.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/userEditAuthDetailBubbleView.tmpl");
    var Button = require("ui/button/Button");

    var UserEditAuthDetailsBubbleView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserEditAuthDetailsBubbleView = Marionette.ItemView.extend({
            template: template,
            ui:{
               authDetailsLink: ".auth-details-link"
            },
            uiComponents:{
                authDetailsLink: {
                    type: Button,
                    options: {
                        el: "view.ui.authDetailsLink",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_onAuthDetailsClick"
                    }
                }
            },

            _onAuthDetailsClick: function(){
                LE.crossModule("manager", LE.mediaCodes.manager.redirects.loadApiKeys);
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UserEditAuthDetailsBubbleView;

});
